/* eslint-disable @typescript-eslint/no-non-null-assertion */
export interface PublicEnv {
  env: 'local' | 'dev' | 'stg' | 'prod'
  host: string
  apiHost: string
  stripe: {
    apiKey: string
  }
  googleMap: {
    apiKey: string
    mapId: string
  }
}

export const publicEnv: PublicEnv = {
  env: process.env.NEXT_PUBLIC_APP_ENV! as any,
  host: process.env.NEXT_PUBLIC_HOST!,
  apiHost: process.env.NEXT_PUBLIC_API_HOST!,
  stripe: {
    apiKey: process.env.NEXT_PUBLIC_STRIPE_KEY!,
  },
  googleMap: {
    apiKey: process.env.NEXT_PUBLIC_API_KEY!,
    mapId: process.env.NEXT_PUBLIC_MAP_ID ?? 'DEMO_MAP_ID',
  },
}
